import {Action} from '@ngrx/store';
import {DeviceDetails, DevicesStatus, DevicesStatusPack} from '../../models/devices';
import {User} from '../../models/user';

// define action types
export const enum DevicesStatusTypes {
  GET_DEVICES_STATUS = '[User Devices] GET_DEVICES_STATUS',
  GET_DEVICES_STATUS_SUCCESS = '[User Devices] GET_DEVICES_STATUS_SUCCESS',
  GET_DEVICES_STATUS_FAIL = '[User Devices] GET_DEVICES_STATUS_FAIL',
  SELECTED_STATUS = '[User Devices] SELECTED_STATUS',
  CLEAR_DEVICES_STATUS = '[User Devices] CLEAR_DEVICES_STATUS',
}

export const enum DeviceDetailsType {
  GET_DEVICE_DETAILS = '[User Devices] GET_DEVICE_DETAILS',
  GET_DEVICE_DETAILS_SUCCESS = '[User Devices] GET_DEVICE_DETAILS_SUCCESS',
  GET_DEVICE_DETAILS_FAIL = '[User Devices] GET_DEVICE_DETAILS_FAIL'
}

// define Actions class
export class GetDevicesStatusAction implements Action {
  readonly type = DevicesStatusTypes.GET_DEVICES_STATUS;

  constructor(public payload: User = null) {
  }
}

export class GetDevicesStatusSuccessAction implements Action {
  readonly type = DevicesStatusTypes.GET_DEVICES_STATUS_SUCCESS;

  constructor(public payload: DevicesStatusPack) {
  }
}

export class GetDevicesStatusFailAction implements Action {
  readonly type = DevicesStatusTypes.GET_DEVICES_STATUS_FAIL;

  constructor(public payload: any = null) {
  }
}

export class SelectedSatus implements Action {
  readonly type = DevicesStatusTypes.SELECTED_STATUS;

  constructor(public payload: number = 0) {
  }
}

export class ClearDevicesStatusAction implements Action {
  readonly type = DevicesStatusTypes.CLEAR_DEVICES_STATUS;

  constructor(public payload: any = null) {
  }
}

export class GetDevicesDetails implements Action {
  readonly type = DeviceDetailsType.GET_DEVICE_DETAILS;

  constructor(public payload: string = null) {
  }
}

export class GetDevicesDetailsSuccess implements Action {
  readonly type = DeviceDetailsType.GET_DEVICE_DETAILS_SUCCESS;

  constructor(public payload: DeviceDetails = null) {
  }
}

export class GetDeviceDetailsFail implements Action {
  readonly type = DeviceDetailsType.GET_DEVICE_DETAILS_FAIL;

  constructor(public payload: any) {
  }
}

export type DevicesStatusActions
  = GetDevicesStatusAction
  | GetDevicesStatusSuccessAction
  | GetDevicesStatusFailAction
  | SelectedSatus
  | GetDevicesDetails
  | GetDevicesDetailsSuccess
  | GetDeviceDetailsFail
  | ClearDevicesStatusAction;
